export default __webpack_public_path__ + "static/media/jp.d634f870.svg";